require('D:/code/sigle/recept-pc-guangxi/node_modules/@aligov/lib/es/style.js');
export { getGlobalConfig, siteConfig } from './common';
export { text, format } from './text';